import { reducerWithInitialState } from 'typescript-fsa-reducers';
import { NetworkStatus } from '@cbridge-utils/network';
import { AdjustmentProfileAction } from './adjustmentProfile.action';
import { adjustmentProfileInitialState } from './adjustmentProfile.constant';

export const adjustmentProfileReducer = reducerWithInitialState(adjustmentProfileInitialState)
  .case(AdjustmentProfileAction.loadList.started, (state) => {
    return {
      ...state,
      networkStatus: NetworkStatus.Started,
    };
  })
  .case(AdjustmentProfileAction.loadList.done, (state, { result }) => ({
    ...state,
    data: result.data,
    defaultData: result.defaultData,
    networkStatus: NetworkStatus.Done,
  }))
  .case(AdjustmentProfileAction.loadList.failed, (state) => {
    return {
      ...state,
      networkStatus: NetworkStatus.Failed,
    };
  })
  .case(AdjustmentProfileAction.remove.done, (state, payload) => {
    const adjustmentProfileData = { ...state.data };
    delete adjustmentProfileData[payload.params.adjustmentId];

    return {
      ...state,
      data: adjustmentProfileData,
    };
  })
  .case(AdjustmentProfileAction.update.done, (state, payload) => {
    return {
      ...state,
      data: payload.result,
    };
  })
  .case(AdjustmentProfileAction.destroy, () => ({
    ...adjustmentProfileInitialState,
  }));
